import axios from "axios";
import { Loading, Message } from "element-ui";
import router from "../router/index.js";
import { sessionSnapshot, isCurrentSession, clearLoginState } from './session';
import { tokenName, baseUrl } from "../config/project";
import i18n from "@/lang/index"; // 动态读 i18n.locale，单一真源，热切换后即时生效
let loading;

function startLoading() {
  loading = Loading.service({
    lock: true,
    text: "加载中....",
    background: "rgba(0, 0, 0, 0.7)",
  });
}

function endLoading() {
  if (loading) {
    loading.close();
  }
}
//超时2分钟
// console.log(axios.defaults)
axios.defaults.timeout = 1000 * 60 * 2;
axios.defaults.baseURL = baseUrl;
// 请求拦截
axios.interceptors.request.use(
  (confing) => {
    const snapshot = confing.sessionSnapshot || sessionSnapshot();
    confing.sessionSnapshot = snapshot;
    if (snapshot.token) confing.headers.Authorization = 'Bearer ' + snapshot.token;
    confing.headers["Accept-Language"] = i18n.locale; // 后端按此选错误文案语言包
    // confing.headers.contentType = ;
    return confing;
  },
  (error) => {
    if (error.config && error.config.skipErrorHandler) {
      return Promise.reject(error);
    }
    Message.error(i18n.t("public.service_error"));
    endLoading();
    return Promise.reject(error);
  }
);

//响应拦截
axios.interceptors.response.use(
  (response) => {
    endLoading();
    if (response.config && response.config.allowStaleResult) return response.data;
    if (response.config && !isCurrentSession(response.config.sessionSnapshot)) {
      return Promise.reject(new Error('请求所属会话已切换'));
    }
    if (response.config && response.config.skipErrorHandler) return response.data;
    //当返回信息为未登录或者登录失效的时候重定向为登录页面
    // if(response.data.code == 'W_100004' || response.data.message == '用户未登录或登录超时，请登录！'){
    //   router.push({
    //     path:"/",
    //     querry:{redirect:router.currentRoute.fullPath}//从哪个页面跳转
    //   })
    // }
    // 获取状态码
    const { code } = response.data;
    if (code === 10031) {
      // 密码策略升级：后端拒绝未重置用户的一切业务请求，强制跳重置页
      localStorage.setItem("needResetPwd", "1");
      // 并发多请求同时返 10031 时只弹一次、只跳一次
      if (router.currentRoute.path !== "/resetPwd") {
        Message.error(response.data.msg || i18n.t("public.need_reset_pwd"));
        router.push("/resetPwd");
      }
      return response.data;
    }
    if (code === 422 || code === 401) {
      Message.error(i18n.t("public.relogin"));
      clearLoginState();
      router.push("/login");
      return response.data; // 401/422 提前 return，防止跌入下方通用错误分支二次弹 toast
    }
    if(code === 403){
      return response.data;
    }
    if (code && code !== 200 && code !== 0 && code !== 401) {
      console.log(code, "code")
      Message.error(
        response.data.msg || response.data.message
      );
      return response.data; // 错误路径也要交出响应体，否则调用方取 res.code 会 TypeError
    } else {
      return response.data;
    }
  },
  (error) => {
    endLoading();
    if (error.config && error.config.skipErrorHandler) {
      return Promise.reject(error);
    }
    if (error.config && !isCurrentSession(error.config.sessionSnapshot)) return Promise.reject(error);
    Message.error(
      error.response
        ? error.response.data.metadata
          ? error.response.data.metadata.msg
          : error.response.data.msg || error.response.data.message || i18n.t("public.service_error")
        : i18n.t("public.network_error")
    );
    if (error.response && error.response.data &&
        (error.response.data.code == 401 || error.response.data.code == 402)) {
      endLoading();
      clearLoginState();
      //跳转到登录页面
      router.push("/login");
    }
    return Promise.reject(error);
    // return error.response.data
  }
);
export default function request(config) {
  // 在拦截器异步执行前捕获会话，退出请求仍携带原凭证。
  return axios({ ...config, sessionSnapshot: sessionSnapshot() });
}
